import { createElement } from 'react';
import { TestIdProps } from '../../util/testId';
import { SettingsDialog, SettingsDialogProps } from './SettingsDialog';

export interface SettingsProps extends TestIdProps, SettingsDialogProps {
  isOpen: boolean;
}

export const Settings = (props: SettingsProps) => {
  return <SettingsDialog {...props} />;
};

// Lazy loaded so must use default export.
export default Settings;
